import React from "react";
import { Button, CircularProgress, Stack, useTheme } from "@mui/material";

export function WizardFooter({
  canGoBack,
  onBack,
  onNext,
  nextLabel,
  isNextDisabled = false,
  isSaving = false,
}) {
  const theme = useTheme();

  return (
    <Stack direction="row" spacing={2} sx={{ mt: { xs: 4, sm: 5 } }}>
      <Button
        variant="outlined"
        onClick={onBack}
        disabled={!canGoBack || isSaving}
        sx={{
          borderColor: "#C4B5FD",
          color: theme.palette.custom.purple[500],
          minWidth: 110,
        }}
      >
        Voltar
      </Button>

      <Button
        variant="contained"
        onClick={onNext}
        disabled={isNextDisabled || isSaving}
        sx={{
          backgroundColor: theme.palette.custom.purple[500],
          boxShadow: "0px 4px 10px rgba(109, 40, 217, 0.3)",
          minWidth: 160,  
          "&:hover": {
            backgroundColor: theme.palette.custom.purple[600] || "#5B21B6",
          },
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <span>{isSaving ? "Salvando..." : nextLabel}</span>

          {isSaving && (
            <CircularProgress size={18} sx={{ color: "#fff" }} />
          )}
        </Stack>
      </Button>
    </Stack>
  );
}
